import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const AdminNavigation: React.FC = () => {
  const location = useLocation();

  const navItems = [
    {
      path: '/admin/therapist-approval',
      label: 'Therapist Approval',
      emoji: '👨‍⚕️',
      description: 'Review and approve therapist applications'
    },
    {
      path: '/admin/grant-access',
      label: 'Grant Access',
      emoji: '🎟️',
      description: 'Grant free access to users'
    },
    {
      path: '/admin/gift-requests',
      label: 'Gift Requests',
      emoji: '🎁',
      description: 'Review individual gift requests from customers'
    },
    {
      path: '/admin/gift-batch-review',
      label: 'Batch Review',
      emoji: '📋',
      description: 'Review multiple gift requests at once'
    },
    {
      path: '/admin/gift-analytics',
      label: 'Gift Analytics',
      emoji: '📊',
      description: 'View gift system analytics and trends'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex space-x-8 overflow-x-auto">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center space-x-2 py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors ${
                  isActive
                    ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
                }`}
              >
                <span className="text-lg">{item.emoji}</span>
                <span>{item.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AdminNavigation; 